export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Requisites',
    },
    cell: {
      type: 'slot',
      name: 'requisite',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Amount',
    },
    cell: {
      type: 'slot',
      name: 'amount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Callback date get',
    },
    cell: {
      type: 'slot',
      name: 'date',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Deal number',
    },
    cell: {
      type: 'slot',
      name: 'dealNumber',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Tran ID',
    },
    cell: {
      type: 'slot',
      name: 'transactionNumber',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Bank sender',
    },
    cell: {
      type: 'text',
      value: (e) => e.senderBank,
    },
  },
];
